import template from './leave_rules.html';
import tr from '../../lib/default-translator.js';

class AdminLeaveRulesViewModel
{
	constructor(page)
	{
		this.page = page;
		this.leave_rules = ko.observableArray();
	}

	async edit_rule(v)
	{
		let data = ko.toJS(v);
		await Grape.dialog.open('LeaveRestrictionRule', { data: data.leave_restriction_rule_id });
		this.page.updateData();
	}

	show_leave_restriction_rules_help()
	{
		Grape.dialog.open('LeaveRestrictionRuleHelp', {});
	};
}

class AdminLeaveRulesPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminLeaveRulesViewModel(this);
	}

	init()
	{
		document.title = tr('Manage Leave Rules');
		window.current_page_title(tr('Leave Restriction Rules'));
	}

	async updateData()
	{
		Grape.cache.invalidate('LeaveRestrictionRules');
		let rules = await Grape.cache.get('LeaveRestrictionRules');
		let sorted_rules = rules.sort((a, b) => a.rule_name.localeCompare(b.rule_name));
		this.viewModel.leave_rules(sorted_rules);
	}
}

export default {
	route: '[/]admin/leave_rules',
	page_class: AdminLeaveRulesPage,
	template: template,
	template_filename: 'translation/leave_rules'
};
